import { onScopeDispose, toValue } from 'vue'
import type { MaybeRefOrGetter, Ref } from 'vue'

/** Call `handler` on a pointer press outside `target`, or on Escape. */
export function useOnClickOutside(
  target: Ref<HTMLElement | null>,
  handler: () => void,
  enabled: MaybeRefOrGetter<boolean> = true,
): void {
  const onPointerDown = (event: PointerEvent) => {
    if (!toValue(enabled)) return
    const node = target.value
    if (node && !node.contains(event.target as Node)) handler()
  }

  const onKeyDown = (event: KeyboardEvent) => {
    if (toValue(enabled) && event.key === 'Escape') handler()
  }

  document.addEventListener('pointerdown', onPointerDown)
  document.addEventListener('keydown', onKeyDown)

  onScopeDispose(() => {
    document.removeEventListener('pointerdown', onPointerDown)
    document.removeEventListener('keydown', onKeyDown)
  })
}
